import { useSelector } from 'react-redux';
import { getSelectedCurrency } from '@app/redux/currency/selectors';
import { getLanguageCode } from '@app/redux/localization/selectors';
import type { RootState } from '@app/redux/types';
import { currencyFormat } from '../utils';

import type { CurrencyFormatterProps } from '../types';

const useCurrencyFormatter = (): (({
  number,
  onlyGreaterThanZero,
  round,
  forcedCurrency,
}: CurrencyFormatterProps) => string) => {
  const { code, currency } = useSelector((state: RootState) => ({
    currency: getSelectedCurrency(state),
    code: getLanguageCode(state),
  }));

  return currencyFormat({ locale: code, currency });
};

export default useCurrencyFormatter;
